import { MessageService } from "./services/message.service";
import { TokenConfirmationComponent } from "./components/token-confirmation/token-confirmation.component";
import { ModalContentLiteComponent } from "./components/common/modal-content-lite/modal-content-lite.component";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgHttpLoaderModule } from "ng-http-loader";
import { ToastrModule } from "ngx-toastr";
import { FormlyModule, ɵa as FORMLY_CONFIG_TOKEN } from "@ngx-formly/core";
import { FormlyBootstrapModule } from "@ngx-formly/bootstrap";
import { FormlyFieldInput, SanremoCheckboxFieldInput, SanremoFieldInputText, SanremoFieldTextarea } from "./components/common/checkbox-template/formly-field-input";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import {
  // ModalContainerComponent,
  ModalModule,
  BsModalService,
  BsModalRef,
  CollapseModule,
  defineLocale,
  BsDropdownModule,
} from "ngx-bootstrap";
import { itLocale, enGbLocale } from 'ngx-bootstrap/locale';
defineLocale('it', itLocale);
defineLocale('en', enGbLocale);

import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxCaptchaModule } from "ngx-captcha";
import { SanremoRecaptchaComponent } from "./components/common/sanremo-recaptcha/sanremo-recaptcha.component";
import { FileWrapperLiteComponent } from "./components/common/file-wrapper-lite/file-wrapper-lite.component";
import {
  CachingInterceptor,
  RequestCache
} from "./interceptors/cache-interceptor";
import { ErrorInterceptor } from "./interceptors/error-interceptor";
import { AuthInterceptor } from "./interceptors/auth-interceptor";
import { JurorRegistrationComponent } from "./components/juror-registration/juror-registration.component";
import { SanremoHeaderLiteComponent } from "./components/sanremo-header-lite/sanremo-header-lite.component";
import { Safe } from "./utilities/utilities";
import { TokenConfirmedComponent } from "./components/token-confirmed/token-confirmed.component";
import { RegistrationSubmittedComponent } from "./components/registration-submitted/registration-submitted.component";
import { HomePageComponent } from './components/home-page/home-page.component';
import { UserRegistrationComponent } from './components/user-registration/user-registration.component';
import { RecordCompanyRegistrationComponent } from './components/record-company-registration/record-company-registration.component';
import { DatePipe } from "@angular/common";
import { LanguagesService } from "./services/languages.service";
import { CurrentRowPipe } from "./pipes/current-row.pipe";
import { DateOrNotPipe } from "./pipes/date-or-not.pipe";
import { TitleCasePipe } from './pipes/title-case.pipe';
import { TranslatePipe } from "./pipes/translate.pipe";
import { DateTimePickerComponent } from "./components/common/date-time-picker/date-time-picker.component";
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { DatepickerComponent } from "./components/common/datepicker/datepicker.component";
import { ErrorComponent } from './components/error/error.component';
import { DropdownMenuComponent } from './components/dropdown-menu/dropdown-menu.component';
import { LatinCharsetAsyncValidatorDirective } from "./validators/latin-charset-validator";
import { RecordCompanyRLRegistrationComponent } from "./components/record-company-rl-registration/record-company-rl-registration.component";
import { PanelWrapperLiteComponent } from './components/common/panel-wrapper-lite/panel-wrapper-lite.component';
import { GdprComponent } from './components/gdpr/gdpr.component';
import { ModalGdprService } from "./services/modal-gdpr.service";
import { FileValueAccessor } from "./validators/file-control-value-accessor";
import { FileInputComponent } from "./components/common/file-input/file-input.component";

@NgModule({
  declarations: [
    AppComponent,
    JurorRegistrationComponent,
    SanremoHeaderLiteComponent,
    FileWrapperLiteComponent,
    ModalContentLiteComponent,
    Safe,
    SanremoRecaptchaComponent,
    TokenConfirmationComponent,
    TokenConfirmedComponent,
    RegistrationSubmittedComponent,
    HomePageComponent,
    UserRegistrationComponent,
    RecordCompanyRegistrationComponent,
    CurrentRowPipe,
    TitleCasePipe,
    DateOrNotPipe,
    DatepickerComponent,
    TranslatePipe,
    DateTimePickerComponent,
    DatepickerComponent,
    SanremoCheckboxFieldInput,
    FormlyFieldInput,
    ErrorComponent,
    DropdownMenuComponent,
    LatinCharsetAsyncValidatorDirective,
    SanremoFieldInputText,
    SanremoFieldTextarea,
    RecordCompanyRLRegistrationComponent,
    PanelWrapperLiteComponent,
    GdprComponent,
    FileValueAccessor,
    FileInputComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgHttpLoaderModule,
    ToastrModule.forRoot({
      maxOpened: 1,
      autoDismiss: true,
      preventDuplicates: true
    }),
    CollapseModule.forRoot(),
    FormlyModule,
    FormlyBootstrapModule,
    FontAwesomeModule,
    ModalModule.forRoot(),
    NgHttpLoaderModule,
    NgxCaptchaModule,
    BsDatepickerModule.forRoot(),
    BsDropdownModule.forRoot(),
    FormlyModule.forRoot({
      types: [
        {
          name: 'file-input',
          component: FileInputComponent,
          wrappers: ["form-field", "file-wrapper-lite"]
        },        
        {
          name: 'datepicker',
          component: DatepickerComponent
        },
        {
          name: 'date-time-picker',
          component: DateTimePickerComponent
        },
        {
          name: 'checkbox',
          component: FormlyFieldInput
        },
        {
          name: 'sanremo-checkbox',
          component: SanremoCheckboxFieldInput
        },
        {
          name: "sanremo-input-lite",
          component: SanremoFieldInputText
        },
        {
          name: "sanremo-area-lite",
          component: SanremoFieldTextarea
        },
        {
          name: "sanremo-recaptcha",
          component: SanremoRecaptchaComponent
        }
      ],
      wrappers: [
        {
          name: "file-wrapper-lite",
          component: FileWrapperLiteComponent
        },
        { 
          name: 'panel', 
          component: PanelWrapperLiteComponent 
        }
      ]
    }),
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
  ],
  providers: [
    RequestCache,
    BsModalService,
    ModalGdprService,
    BsModalRef,
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CachingInterceptor, multi: true },
    MessageService,
    DatePipe
  ],
  entryComponents: [ModalContentLiteComponent, GdprComponent ],
  bootstrap: [AppComponent]
})
export class AppModule { }
